<template>
    <div class="model-compared">
        <div class="model-compared-header">
            <el-button type="primary" @click="dialogVisible = true" round>模型对比</el-button>
            <el-button type="danger" disabled round>删除文件</el-button>
        </div>
        <el-table :data="modelAssembleList" stripe style="width: 100%;">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="packageName" label="对比名称" width="180"></el-table-column>
            <el-table-column prop="startTime" label="开始时间" width="180"></el-table-column>
            <el-table-column prop="num" label="组装文件数"></el-table-column>
            <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                    <span style="color: #22c00e;">组装成功</span>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <i @click="viewModelAssemble(scope.row)" class="model-compared-icon el-icon-view"></i>
                    <i @click="editModelAssemble(scope.row)" class="model-compared-icon el-icon-s-tools"></i>
                    <!--                    <i class="el-icon-share"></i>-->
                    <i
                        @click="delModelAssemble(scope.row)"
                        class="model-compared-icon model-compared-icon-del el-icon-delete"
                    ></i>
                </template>
            </el-table-column>
        </el-table>
        <SelectViewerDialog
            @add-view="addView"
            @ok="saveModelAssemble"
            @close="closeDialog"
            :dialogVisible="dialogVisible"
            title="模型对比"
            headerName="对比名称"
        >
        </SelectViewerDialog>
        <el-dialog title="模型对比参数编辑" :visible.sync="editDialogVisible" width="40%" :before-close="handleClose">
            模型对比参数编辑
            <span slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveModelAssemblePosition">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {
    addModelAssembleRequest,
    deleteModelAssemble,
    editModelAssembleView,
    getModelAssembleList,
    getModelAssembleView,
} from '../../../../utils/modelAssemble';
import SelectViewerDialog from '../ModelAssemble/SelectViewerDialog';
const addModelAssembleTmp = {
    packageName: '',
    num: 0,
    packageParamsMetadataList: [],
};
export default {
    name: 'modelAssemble',
    components: {
        SelectViewerDialog,
    },
    data() {
        return {
            addModelAssemble: {},
            dialogVisible: false,
            editDialogVisible: false,
            modelAssembleList: [],
        };
    },
    methods: {
        saveModelAssemblePosition() {
            if (!this.editModelAssembleData.packageName) {
                this.$message.warning('请输入模型组装的名称!');
                return;
            }
            editModelAssembleView(this.editModelAssembleData.packageParamsMetadataList).then(() => {
                this.$message.success('修改成功!');
                this.editModelAssembleData = {};
            });
        },
        viewModelAssemble(row) {
            const tempURL = `${window.location.origin}/devcenter/console/view?viewModelType=assemble&assembleId=${row.id}`;
            window.open(tempURL, '_blank');
        },
        editModelAssemble(row) {
            getModelAssembleView(row.id).then((data) => {
                this.editModelAssembleData = row;
                this.editModelAssembleData.packageParamsMetadataList = data;
                this.editDialogVisible = true;
            });
        },
        delModelAssemble(row) {
            deleteModelAssemble(row.id).then(() => {
                this.$message.success('删除成功!');
                this.getModelAssembleList();
            });
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {});
        },
        closeDialog() {
            this.dialogVisible = false;
        },
        saveModelAssemble(name) {
            if (!name) {
                this.$message.warning('请输入模型组装的名称!');
                return;
            }
            if (this.addModelAssemble.packageParamsMetadataList.length <= 0) {
                this.$message.warning('请选择视图!');
                return;
            }
            this.addModelAssemble.packageName = name;
            this.addModelAssemble.num = this.addModelAssemble.packageParamsMetadataList.length;
            addModelAssembleRequest(this.addModelAssemble)
                .then(() => {
                    this.closeDialog();
                    this.getModelAssembleList();
                })
                .catch((e) => {
                    this.$message.error('保存失败请重试!' + e);
                });
        },
        addView({ urn, view, object }) {
            // 使用displayName 判断因为 文件的object key 不一样 但是 guid 会有可能一样
            const displayName = object.object_key + '_' + view.name;
            const item = this.addModelAssemble.packageParamsMetadataList.find(
                (item) => item.displayName === displayName,
            );
            if (item) {
                this.$message.warning('当前视图已经添加到已选文件视图中，不能重复添加!');
                return;
            }
            this.addModelAssemble.packageParamsMetadataList.push({
                guid: view.guid,
                x: 0,
                y: 0,
                z: 0,
                urn: urn,
                displayName,
            });
        },
        removeView(view) {
            const index = this.addModelAssemble.packageParamsMetadataList.findIndex(
                (item) => item.displayName === view.displayName,
            );
            if (index !== -1) {
                this.addModelAssemble.packageParamsMetadataList.splice(index, 1);
            }
        },
        async getModelAssembleList() {
            this.modelAssembleList = await getModelAssembleList();
        },
    },
    mounted() {
        this.addModelAssemble = addModelAssembleTmp;
        this.getModelAssembleList();
    },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.model-compared
  width: 88%
  .model-compared-header
    padding 15px 15px
  .model-compared-icon
    padding 5px 8px
    cursor pointer
    font-size 15px
  .model-compared-icon:hover
    color #0C78E2
  .model-compared-icon-del:hover
    color #e20c25 !important
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/ModelCompared/ModelCompared.vue